/**
 * Días en hora LOCAL, no UTC.
 *
 * `new Date().toISOString().slice(0,10)` da el día en UTC. En México (UTC-6) una venta de
 * las 19:00 se contabiliza al día siguiente: el corte del día no cierra y el comerciante ve
 * ventas que "no son de hoy". El historial de v1 no lo notaba porque el filtro por fecha lo
 * hacía el backend; al mover el corte al cliente, esto pasa a ser nuestro.
 */
export function diaLocal(fecha: Date | string): string {
  const d = typeof fecha === "string" ? new Date(fecha) : fecha;
  const off = d.getTimezoneOffset() * 60_000;
  return new Date(d.getTime() - off).toISOString().slice(0, 10);
}

export function hoyLocal(): string {
  return diaLocal(new Date());
}
